/*
 * Module for the Counseling Appointments Index view
*/
rs.module("ui/content/events/counselingappointments/index",

    [],

    function () {

        // Initialize the module
        function initialize(jsSelectors, backendUrls) {

            // Unpack Js Selectors
            var filterSelect = $.js(jsSelectors.filterSelect);
            var counselingAppointments = $.js(jsSelectors.counselingAppointments);
            var skeleton = $.js(jsSelectors.skeleton);

            // Handle the filter select change event.
            filterSelect.change(function () {

                // Show skeleton while we load content.
                skeleton.show();
                counselingAppointments.hide();

                // Retrieve appointments list
                $.get(
                    backendUrls.getCounselingAppointmentsList,
                    {
                        upcomingOnly: $(this).val()
                    })
                    .done(function (html) {
                        counselingAppointments.html(html);
                    })
                    .always(function () {
                        skeleton.hide();
                        counselingAppointments.show();
                    });
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);